import React from 'react';
import CreateJobContent from './content';
import { NewCareerPositionProvider } from 'contexts/career-position.context';

const CreateCareerPositionLayout = () => {
  return (
    <NewCareerPositionProvider>
      <CreateJobContent />
    </NewCareerPositionProvider>
  );
};

export default CreateCareerPositionLayout;
